mutation refreshToken($token: String!) {
  refreshToken(token: $token) {
    token
  }
}
